---
version: "v1.3"
title: "Rich PDF reports, team management, and SSO polish"
date: 2026-08-12
excerpt: "Report PDFs are now fully designed documents instead of a browser print-out, team management gets email invites and domain-based auto-join, and SSO login/config get a round of fixes."
---

## Rich PDF reports

**Download PDF** on any report now generates a properly designed document — DebtDrone branding, health stats, and the dependency/complexity findings laid out for reading and sharing, not a screenshot of the dashboard. Previously this just triggered your browser's print dialog; it's now a real PDF built and rendered on our servers, so it looks the same regardless of what browser or OS you're on.

## Team management

- **Invite by email** — org owners and admins can invite teammates directly by email with a role (owner/admin/member/viewer) instead of only adding people who already have a DebtDrone account.
- **Verified domains** — on plans with SSO, you can verify ownership of your company's email domain (via a TXT DNS record) and let anyone signing up with that domain request to join your org automatically, instead of inviting each person one by one.
- **Join requests** — requests from a verified domain show up in Team Members for an owner/admin to approve or deny.

## SSO fixes

- Logging in with a work email tied to an SSO organization now automatically redirects to your identity provider — no need to know to look for a separate "Sign in with SSO" option.
- The SAML configuration page now correctly restricts uploading/editing Identity Provider metadata to org owners and admins; other members see a read-only view instead of an upload form they can't use.
